import { render, staticRenderFns } from "./pageTop.vue?vue&type=template&id=0b7b3436&scoped=true"
import script from "./pageTop.vue?vue&type=script&lang=js"
export * from "./pageTop.vue?vue&type=script&lang=js"
import style0 from "./pageTop.vue?vue&type=style&index=0&id=0b7b3436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b3436",
  null
  
)

export default component.exports